import React from 'react';
import { GoogleLoginButton } from 'react-social-login-buttons';
import './Login.css';

const Login = () => {
  const handleGoogleLogin = () => {
    window.location.href = '/auth/google';
  };

  return (
    <div className="auth-container">
      <h1 className="auth-title">Увійдіть</h1>
      <div className="login-button-wrapper">
        <GoogleLoginButton onClick={handleGoogleLogin} />
      </div>
    </div>
  );
};

export default Login;
